import React, { type HTMLAttributes } from 'react';
import c from 'classnames';

import { DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container, Text } from '@uncinc/uncinc-react-kitchen-sink';

import { ParagraphTextMedia as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

export interface ParagraphTextMediaProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphTextMedia: React.FC<ParagraphTextMediaProps> = ({ entity }) => {
  const paragraph = entity.toJS();
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0].processed;
  const image = paragraph.field_media_image[0];

  const classNames = c('Paragraph', 'ParagraphTextMedia');

  return (
    <div className={classNames}>
      <Container>
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="ParagraphTextMedia__media-wrapper">
              <DynamicMediaItem
                // @ts-expect-error
                media={image}
                imageAspectRatio="1_1"
              />
            </div>
          </div>

          <div className="col-12 col-lg-6">
            <div className="ParagraphTextMedia__body-wrapper">
              <div className="ParagraphTextMedia__body">
                <Text
                  title={title}
                  text={body}
                />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphTextMedia;
